import React from 'react';
import PageShell from '@/components/PageShell';
import AreasServedSection from '@/components/sections/AreasServedSection';

const AreasServed = () => (
  <PageShell
    title="Vapour Blasting Near Me | Christchurch & Canterbury NZ"
    description="Vapour blasting across Christchurch, Hornby, Riccarton, Rolleston, Rangiora, Ashburton and Timaru. Ship parts from anywhere in NZ."
    canonicalPath="/areas-served"
    crumbs={[{ name: 'Areas Served', path: '/areas-served' }]}
  >
    <AreasServedSection />
  </PageShell>
);

export default AreasServed;
